(function () {
  'use strict';

  var gallery = document.getElementById('pdp-gallery');
  if (!gallery) return;

  var imgs = Array.from(gallery.querySelectorAll('.pdp-gallery-img'));
  var btns = Array.from(document.querySelectorAll('.spinner-feature-btn'));

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.img, 10);
      var isActive = btn.classList.contains('active');

      imgs.forEach(function (img) { img.classList.remove('active'); });
      btns.forEach(function (b) { b.classList.remove('active'); });

      if (isActive) {
        imgs[0].classList.add('active');
      } else {
        btn.classList.add('active');
        imgs[idx].classList.add('active');
      }
    });
  });
})();
